<div class="input-row">
    <fieldset>
        <mat-form-field appearance="fill">
            <mat-label>{{label}}</mat-label>
            <input [scanInput] #locationInput matInput scanInput="BIN" [value]="locationID" [placeholder]="placeholder"
                (scanned)="onLocationEntered($event)" [disabled]="disabled" autofocus />
        </mat-form-field>
    </fieldset>
</div>